import type { DatasetImageNodeProps } from "./dataset-image-node.type";

import { Image } from "antd";

import { useReferentialMaterialsDefects } from "@/entities/referential/referential-materials";
import { ImageWithAnnotation } from "@/ui/image-with-annotation";
import { ImageWithBoundingBoxes } from "@/ui/image-with-bounding-boxes";

import { getImageBoundingBoxes } from "./dataset-image-node.helper";

export const DatasetImageNode = ({
  src,
  alt,
  labeling,
  hideBoundingBoxLabels,
}: DatasetImageNodeProps) => {
  const { defects } = useReferentialMaterialsDefects();

  if (labeling?.type === "annotation") {
    return <ImageWithAnnotation src={src} alt={alt} svg={labeling.data.svg} />;
  }

  if (labeling?.type === "boundingBox") {
    const boundingBoxes = getImageBoundingBoxes(labeling, defects);
    return (
      <ImageWithBoundingBoxes
        src={src}
        alt={alt}
        boundingBoxes={boundingBoxes}
        hideLabels={hideBoundingBoxLabels}
      />
    );
  }

  return <Image src={src} alt={alt} preview={false} />;
};
